import { createSlice } from "@reduxjs/toolkit";

const previousUsersSlice = createSlice({
  name: "previousUsers",
  initialState: {
    previousUsers: [],
  },
  reducers: {
    addToPreviousUsers: (state, action) => {
      const selectedCustomer = action.payload;
      const indexOfCustomer = state.previousUsers.findIndex(
        (user) => user.id === selectedCustomer.users.id
      );
      // state.previousUsers = [selectedCustomer, ...state.previousUsers];

      if (indexOfCustomer === -1) {
        if (state.previousUsers.length >= 5) {
          state.previousUsers = [
            selectedCustomer.users,
            ...state.previousUsers.slice(0, 4),
          ];
        } else {
          state.previousUsers = [
            selectedCustomer.users,
            ...state.previousUsers,
          ];
        }
      } else {
        state.previousUsers = [
          selectedCustomer.users,
          ...state.previousUsers.slice(0, indexOfCustomer),
          ...state.previousUsers.slice(indexOfCustomer + 1),
        ];
      }
    },

    clearPreviousUsers: (state) => {
      state.previousUsers = [];
    },

    removeFromPreviousUsers: (state, action) => {
      const idToDelete = action.payload;
      state.previousUsers = state.previousUsers.filter(
        (user) => user.id !== idToDelete
      );
    },
  },
});

export const { addToPreviousUsers, removeFromPreviousUsers, clearPreviousUsers } =
  previousUsersSlice.actions;
export default previousUsersSlice.reducer;
